import { useFormApi, useFormState } from "informed";
import * as React from "react";
import { nameof } from "ts-simple-nameof";
import { Device, Site, Subject, WebPortalClient, DeviceType } from "webportalclient";
import { DeviceTypes, QueryCondition } from "../../misc/api/apiTypes";
import { MultiSelect } from "../../forms/informedv2/MultiSelect";
import { TextBox } from "../../forms/informedv2/TextBox";
import { Required } from "../../forms/validation/Required";

export interface DevicesFormModel {
    deviceType: DeviceType;
    serialNumber: any;
    allocatedSite: Site;
    allocatedSubject: Subject;
}

export interface DeviceFormProps {
    editMode: boolean;
    clientDevices: any[];
    sites: Site[];
    subjects: Subject[];
    deviceTypes: DeviceType[];
}

export const DeviceForm = ({ editMode, clientDevices, sites, subjects, deviceTypes }: DeviceFormProps) => {
    const formApi = useFormApi<DevicesFormModel>();
    const formState = useFormState<DevicesFormModel>();

    return (
        <div className="row">
            <div className="col-md-12">
                <div id="devicesFormPanel" className="panel panel-primary">
                    <div className="panel-body">
                        <div className="row">
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="SerialNumber">Serial Number</label>
                                <MultiSelect
                                    disabled={!clientDevices.length || editMode}
                                    id="SerialNumber"
                                    field={nameof<DevicesFormModel>(f => f.serialNumber)}
                                    options={clientDevices}
                                    validate={Required}
                                    labelKey="serial"
                                    valueKey="id"
                                    multi={false}
                                />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="DeviceType">Device Type</label>
                                <MultiSelect
                                    disabled={!deviceTypes.length}
                                    id="DeviceType"
                                    field={nameof<DevicesFormModel>(f => f.deviceType)}
                                    validate={Required}
                                    options={deviceTypes}
                                    labelKey="name"
                                    valueKey="id"
                                    multi={false}
                                    onChange={() => {
                                        if (formApi.getValue(nameof<DevicesFormModel>(f => f.allocatedSite)))
                                            formApi.setValue(nameof<DevicesFormModel>(f => f.allocatedSite), null)

                                        if (formApi.getValue(nameof<DevicesFormModel>(f => f.allocatedSubject)))
                                            formApi.setValue(nameof<DevicesFormModel>(f => f.allocatedSubject), null)
                                    }}
                                />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="AllocatedSite">Allocated Site</label>
                                <MultiSelect
                                    disabled={!sites.length || !formState.values.deviceType || formState.values.deviceType?.id !== DeviceTypes.Spirotrac6}
                                    id="AllocatedSite"
                                    field={nameof<DevicesFormModel>(f => f.allocatedSite)}
                                    options={sites}
                                    labelKey="number"
                                    valueKey="id"
                                    multi={false}
                                />
                            </div>
                            <div className="form-group col-md-6 col-sm-6 col-xs-12">
                                <label htmlFor="AllocatedSubject">Allocated Subject</label>
                                <MultiSelect
                                    disabled={!subjects.length || !formState.values.deviceType || formState.values.deviceType?.id === DeviceTypes.Spirotrac6}
                                    id="AllocatedSubject"
                                    field={nameof<DevicesFormModel>(f => f.allocatedSubject)}
                                    options={subjects}
                                    labelKey="number"
                                    valueKey="id"
                                    multi={false}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>);
}
